import React from 'react';
import { DatePicker } from 'rsuite';
import moment from 'moment';
import {
  diffrenceBetweenTwoDates,
  getDiffrenceInDays,
} from "../../../utils/commonfunction";

const PRIMARY_SINGLE_CAT_ID = "cat_single_primary";
const PRIMARY_DOUBLE_CAT_ID = "cat_double_primary";

const fallbackRoomCategories = () => [
  { id: PRIMARY_SINGLE_CAT_ID, label: "Single room", occupancy: "single" },
  { id: PRIMARY_DOUBLE_CAT_ID, label: "Double room", occupancy: "double" },
];

const CustomDateTimePickerHotel = (props) => {
  const {
    formikRef,
    quotaStore,
    setQuotaStore
  } = props;

  function handleChange(datetime) {
    props.setField(props.fieldname, datetime);

    if (props?.correspondingEndDate) {
      const totalDays = diffrenceBetweenTwoDates(datetime, props.correspondingEndDate);
      if (totalDays <= 0) {
        formikRef?.current?.setFieldValue(props.correspondingEndDateName, null);
      }
    }

    setTimeout(() => {
      const formikValues = formikRef?.current?.values;
      const startDate = formikValues?.hotelStartDate;
      const endDate = formikValues?.hotelEndDate;

      if (startDate && endDate) {
        const totalDays = getDiffrenceInDays(startDate, endDate);
        const addedDays = totalDays + 1;

        if (addedDays > 0) {
          const currentFormikQuota = formikValues.hotelTotalDays || [];

          // Update quotaStore with formik's current data
          const updatedStore = { ...quotaStore };
          currentFormikQuota.forEach((item) => {
            const key = moment(item.date, ["YYYY-MM-DD", "DD-MM-YYYY"]).format("YYYY-MM-DD");
            updatedStore[key] = { ...updatedStore[key], ...item, date: key };
          });
          setQuotaStore(updatedStore);

          const newQuotaList = [];
          let current = moment(startDate);
          const roomCategories =
            formikRef?.current?.values?.roomCategories || fallbackRoomCategories();

          for (let i = 0; i < addedDays; i++) {
            const dateStr = current.format("YYYY-MM-DD");
            const existing = updatedStore[dateStr];
            const categoryQuota = {};
            roomCategories.forEach((c) => {
              const prev = existing?.categoryQuota?.[c.id];
              if (prev) {
                categoryQuota[c.id] = { ...prev };
              } else {
                categoryQuota[c.id] = {
                  enabled:
                    c.id === PRIMARY_SINGLE_CAT_ID ||
                    c.id === PRIMARY_DOUBLE_CAT_ID,
                  totalQuantity: "",
                  price: "",
                  breakfastPrice: "",
                };
              }
            });

            newQuotaList.push({
              id: i,
              date: dateStr,
              categoryQuota,
              _id: existing?._id || undefined,
            });

            current.add(1, "day");
          }

          formikRef?.current?.setFieldValue("hotelTotalDays", newQuotaList);
        }
      }
    }, 300);
  }

  const handleBlur = () => {
    props.setFieldTouched(props.fieldname, true);
  };

  return (
    <div className="row col-md6">
      <DatePicker
        disabled={props.disabled || false}
        className="col-md6"
        oneTap={true}
        placeholder={props.placeholder || "Select date"}
        onChange={handleChange}
        onBlur={handleBlur}
        value={props.value || null}
        cleanable={true}
        editable={false}
        shouldDisableDate={(current) => {
          if (props?.endDate) {
            if (props?.correspondingStartDate) {
              return moment(current).isBefore(props.correspondingStartDate, 'day');
            } else {
              return moment().add(-1, 'days') >= current;
            }
          } else {
            return moment().add(-1, 'days') >= current;
          }
        }}
      />
    </div>
  );
};

export default CustomDateTimePickerHotel;

